require("clover/panel/base/BasePanel")
let maintenanceRes = [
    "cocos/maintenance.plist",
    "cocos/maintenance_clock.csb",
    "cocos/maintenance_maintenance.csb",
    "font/zzgftongxin_70_brownstroke.fnt",
    "font/zzgftongxin_40_aquastroke.fnt"
]
let maintenanceFullRes = [
    "cocos/maintenance.plist",
    "cocos/maintenance_clock.csb",
    "cocos/maintenance_maintenance.csb",
    "font/zzgftongxin_70_brownstroke.fnt",
    "font/zzgftongxin_40_aquastroke.fnt",
    "cocos/uilibrary.plist"
]

let MaintenancePanel = xClass("MaintenancePanel", BasePanel, function(){
    return cc.CSLoader.createNode("cocos/maintenance_maintenance.csb")
})

MaintenancePanel.show = function (parent, beginTime, endTime, firstNotice, secondNotice, callback) {
    var onSuccess = function(){
        var panel = MaintenancePanel.create(beginTime, endTime, firstNotice, secondNotice, callback);
        panel.popup();
        parent.addChild(panel);
    }
    preloadWithLoading(maintenanceFullRes, onSuccess, ()=>{Toast.make("load failed")}, ()=>{Toast.make("load success")}, false);
}

MaintenancePanel.preload = function () {
    return preloadWithLoadingPromise(maintenanceRes, true);
}

MaintenancePanel.prototype.ctor = function (beginTime, endTime, firstNotice, secondNotice, finishCallback) {
    var self = this;
    BasePanel.prototype.ctor.call(self);
    self.endTime = endTime * 0.001
    //console.log("@@@@ time ", firstNotice, secondNotice)
    self.title = self.getChildByName("title")
    self.title.setString("停服公告")
    self.content = self.getChildByName("txt2")
    //self.content.setString("由于服务器数据升级维护，我们将于2020年9月26日，27日凌晨1点进行两次停服维护，预计单次维护时间5小时，如停服期间未完成维护则开服时间顺延。给各位小船员带来的不便还请谅解。")
    self.content.setString(firstNotice)
    self.content2 = self.getChildByName("txt3")
    //self.content2.setString("我们将于27日维护后发放本次维护补偿，感谢您的理解和支持！")
    self.content2.setString(secondNotice)
    self.timeRoot = self.getChildByName("pnl_groove_cut")
    self.callback = finishCallback
    if (self.timeRoot){
        self.clock = self.timeRoot.getChildByName("clock")

        console.log("@@@@ get action ", self.clock.getActionByTag)
        let ani = self.clock.getActionByTag(self.clock.getTag())
        ani.gotoFrameAndPlay(0, true)

        let leftTime = endTime - Localhost.timeInSec()
        if (leftTime <= 0){
            leftTime = 0
        }
        self.timeTxt = self.timeRoot.getChildByName("time2")
        self.countDownInterval = setInterval(() => {
            let leftTime = self.endTime - Localhost.timeInSec()
            if (leftTime <= 0){
                leftTime = 0
                self.RefreshMainenanceTime()
                //clearInterval(self.countDownInterval)
                //self.closePanel()
            }
            //else{
             //   self.RefreshMainenanceTime()
            //}
            //self.timeTxt.setString(leftTime)
            self.refreshTimelabel(self.endTime)
        }, 15000);
        self.refreshTimelabel(self.endTime)
    }
}

MaintenancePanel.prototype.refreshTimelabel = function (endTime, checkClose) {
    var self = this
    let leftTime = endTime - Localhost.timeInSec()
    let hour = Math.floor(leftTime / 3600)
    let min = Math.ceil((leftTime - hour * 3600) / 60)
    let str = string.format("%d小时%d分", hour, min)
    //console.log("@@@@time get h&m ", hour, min)
    self.timeTxt.setString(str)

    if (checkClose){
        if (endTime - Localhost.timeInSec() <= 0){
            if (self.callback){
                self.closePanel()
            }
        }
    }
}

MaintenancePanel.prototype.popup = function () {
    var self = this
    var targetScale = self.getScale()
    self.setScale(0)
    var time = 7 / 30
    var targetPos = cc.pAdd(cc.p(self.getPosition()), cc.p(40-display.width/2, 1000-display.height/2));
    self.setScale(0.23)
    self.setPosition(display.width / 2 - 350, 800-display.height/2);
    //self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale), cc.MoveTo.create(time, targetPos)))))
   
    self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(time, targetScale)))))
    return self
}

MaintenancePanel.prototype.closePanel = function () {
    let self = this

    clearInterval(self.countDownInterval)
    self.countDownInterval = null
    ResManager.release(maintenanceRes)
    self.removeFromParentAndCleanup(true)
    if (self.callback){
        self.callback()
    }
}

MaintenancePanel.prototype.RefreshMainenanceTime = function(){
    var self = this;
    let callback = {}
    callback.handler = function (target, data) {
        if (target == "login_getMaintainTime") {
            //Toast.make("refresh success")
            console.log("@@@@ refresh success ", JSON.stringify(data))
            self.endTime = data.second * 0.001
            self.refreshTimelabel(self.endTime, true)
        }else{
            console.log("@@@@ method error")
        }
    };
    callback.onFail = function (err) {
        let errMsg = "[login_getClientConfig] failed. err="+err;
        //window.logCenter && logCenter.error(new Error(errMsg), 'InitResError');
        Toast.make("refresh faile")
        console.log("@@@@ refresh fail ")
    }
    callback.onTimeOut = function (err) {
        let errMsg = "[login_getClientConfig] failed. err=timeout";
        window.logCenter && logCenter.error(new Error(errMsg), 'InitResError');
        Toast.make("refresh time out")
        console.log("@@@@ refresh time out ")
    }

    function parse_response(result) {
        let data
        try {
            let tmpResult = JSON.parse(result)
            data = tmpResult["maintainTime"]
            console.log("@@@@ first&&sec:", data['first'], data['second'])
        } catch (error) {
            console.error("getClient parse error", result, error)
            data = table()
        }

        return [true, {code:0, data:data, desc:0}]
    }
    
    let Http = require("clover/utils/Http")
    let param = [{},[{"method": "login_getMaintainTime"}]]
    Http.send(Http.loginHost + "?" + Http.hostQuery, Http.POST, param, callback, null, "login_getMaintainTime", parse_response)
}


module.exports = MaintenancePanel